import React, { useEffect, useMemo, useState } from 'react';
import { useMuiGridServerSide } from "../../../hooks/useMuiGridServerSide";
import { DataGridPremium, GRID_AGGREGATION_ROOT_FOOTER_ROW_ID, GridActionsCellItem } from '@mui/x-data-grid-premium';
import { useTranslation } from "react-i18next";
import { LOANS_APPLICATION } from "../locales/namespaces";
import { Typography, Box, Grid, Button, useMediaQuery, DialogContent, Checkbox, } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { useWizard } from "../../loanApplication/LoanApplicationContext";
import useUserData from "../../../../src/hooks/user/useUserData";
import Dialog from '@mui/material/Dialog';
import moment from "moment";
import { muiGridLocales } from "../../../../src/helpers/muiGridLocales";
import { CustomPagination } from "../../../../src/components/dataGridCustom/customPagination";
import { mapLoan } from "../../../../src/modules/loans/types/map";
import useLoanStatus from "../../../../src/modules/parameters/hooks/useLoanStatus";
import useLoanType from "../../../../src/modules/parameters/hooks/useLoanType";
import alphaLogo from '../../../../src/assets/images/banks/alphabank.jpg';
import ethnikiLogo from '../../../../src/assets/images/banks/ethniki.jpg';
import eurobankLogo from '../../../../src/assets/images/banks/eurobank.jpg';
import optimaLogo from '../../../../src/assets/images/banks/optima.jpg';
import piraeusLogo from '../../../../src/assets/images/banks/piraeus.jpg';
import atticabankLogo from '../../../../src/assets/images/banks/atticabank.png';
import pendingBank from '../../../../src/assets/images/banks/bank-image-pending.png';
import SaveIcon from '../../../../src/assets/images/icons/saveIcon';
import CancelIcon from '../../../../src/assets/images/icons/cancelIcon';
import Copy from "../../../../src/assets/images/icons/buttonsIcons/copyPopup";


const CopyLoanPopup = ({ open, onClose , onCopy, isCurrentLoan, relatedApps}) => {
    const { copyStructure } = useWizard();
    const [selectedLoanId, setSelectedLoanId] = useState(null);
    const [notSelectedLoanId, setNotSelectedLoanId] = useState(false);

    const { t } = useTranslation(LOANS_APPLICATION)
    const url = `loan/indexTable/data`
    const { language } = useUserData()
    const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

	const bankLogos = {
		alphabank: alphaLogo,
		ethniki: ethnikiLogo,
		eurobank: eurobankLogo,
		optima: optimaLogo,
		piraeus: piraeusLogo,
		attica: atticabankLogo,
	};

	const getBankLogoKey = (bankId) => {
		switch (bankId) {
			case '1':
				return 'ethniki';  
			case '2':
				return 'eurobank'; 
			case '3':
				return 'alphabank';
			case '4':
				return 'piraeus';
			case '5':
				return 'optima';
			case '6':
				return 'attica';
			default:
				return null;
		}
	};


    const getStructureData = () => {

        if (!selectedLoanId) {
            return setNotSelectedLoanId(true)
        }

        copyStructure({
            loanId: isCurrentLoan,
            selectedLoanId: selectedLoanId,
            onSuccess: (data) => {
                onCopy(data)
            },
        });
    };

    const { loanStatus } = useLoanStatus()
    const { loanType } = useLoanType()

    const columns = useMemo(() => [
        {
            field: 'select',
            headerName: '',
            width: 50,
            minWidth: 50,
            maxWidth: 50,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => {                
                return (
                    <>
                        <Checkbox
                            color="primary"
                            sx={{
                                '& .icon.MuiBox-root': {
                                    border: '2px solid #485476',
                                    borderRadius: '8px',
                                    width: '25px',
                                    height: '25px',
                                },
                                '& .anticon': {
                                    border: 'none !important'
                                },
                                '& .anticon svg': {
                                    height: '25px',
                                    width: '25px',
                                    borderRadius: '8px',
                                    position: 'relative',
                                    fill: '#485476',
                                },
                                '& .filled': {
                                    top: '-2px !important',
                                    left: '-2px !important',
                                }

                            }}
                            checked={selectedLoanId === params.row.LoanId}
                            onChange={() => {
                                setSelectedLoanId(params.row.LoanId)
                                setNotSelectedLoanId(false)
                            }}
                        />
                    </>
                )
            }
        },
        {
            field: 'CreatedAt',
            headerName: t('Created'),
            maxWidth: 200, flex: 1, type: 'date',
            headerAlign: 'left',
            disableColumnMenu: true,
            hideable: false,
            valueFormatter: params =>
                moment(params?.value).format("DD-MM-YYYY"),
            aggregable: false,
        },
        {
            field: 'LoanPurpose',
            headerName: t('Loan purpose'),
            maxWidth: 280, flex: 1,
            aggregable: false,
            disableColumnMenu: true,
            headerAlign: 'left',
            valueGetter: (params) => {
                return language === 'el' ? params.row.TypeEL : params.row.TypeEN;
            }
        },
        {
            field: 'Bank',
            headerName: t('Bank'),
            maxWidth: 280,
            flex: 1,
            fontSize: '12px',
            color: '#8891AC',
            headerAlign: 'center',
            disableColumnMenu: true,
            aggregable: false,
            renderCell: (params) => {

                const logoKey = getBankLogoKey(params.row.BankId);
                const logoSrc = bankLogos[logoKey];

                return logoSrc ? (
                    <img
                        src={logoSrc}
                        alt={(params.row.BankId || '')}
                        style={{ width: '128px', margin: '0 auto' }}
                    />
                ) : (
                    <span>
                        <img src={pendingBank} alt='pendingBank' style={{ width: '128px', margin: '0 auto' }}/>
                    </span>
                );
            }
        },
    ], [selectedLoanId])


        const columnsMobile = useMemo(() => [
        {
            field: 'select',
            headerName: '',
            width: 50,
            minWidth: 50,
            maxWidth: 50,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => {                
                return (
                    <>
                        <Checkbox
                            color="primary"
                            sx={{
                                '& .icon.MuiBox-root': {
                                    border: '2px solid #485476',
                                    borderRadius: '8px',
                                    width: '25px',
                                    height: '25px',
                                },
                                '& .anticon': {
                                    border: 'none !important'
                                },
                                '& .anticon svg': {
                                    height: '25px',
                                    width: '25px',
                                    borderRadius: '8px',
                                    position: 'relative',
                                    fill: '#485476',
                                },
                                '& .filled': {
                                    top: '-2px !important',
                                    left: '-2px !important',
                                }

                            }}
                            checked={selectedLoanId === params.row.LoanId}
                            onChange={() => {
                                setSelectedLoanId(params.row.LoanId)
                                setNotSelectedLoanId(false)
                            }}
                        />
                    </>
                )
            }
        },
        {
            field: 'CreatedAndPurpose',
            flex: 1,
            headerAlign: 'left',
            disableColumnMenu: true,
            aggregable: false,
            renderHeader: () => (
                <Box sx={{ fontSize: '11px', lineHeight: 1.2, color:'#8891AC', minWidth: '150px'}}>
                    <Box style={{ marginBottom:'4px'}}>{t('Created')}</Box>
                    <Box>{t('Loan purpose')}</Box>
                </Box>
            ),
            renderCell: (params) => {
                const created = moment(params.row.CreatedAt).format("DD-MM-YYYY");
                const purpose = language === 'el' ? params.row.TypeEL : params.row.TypeEN;

                return (
                <Box sx={{ lineHeight: '1.5' }}>
                    <Box>{created}</Box>
                    <Box>{purpose}</Box>
                </Box>
                );
            }
        },


        {
            field: 'Bank',
            headerName: t('Bank'),
            maxWidth: 280,
            flex: 1,
            fontSize: '12px',
            color: '#8891AC',
            headerAlign: 'center',
            disableColumnMenu: true,
            aggregable: false,
            renderCell: (params) => {
                const logoKey = getBankLogoKey(params.row.BankId);
                const logoSrc = bankLogos[logoKey];
                return logoSrc ? (
                    <img
                        src={logoSrc}
                        alt={(params.row.BankId || '')}
                        style={{ width: '100%', margin: '0 auto', maxWidth:'80px' }}
                    />
                ) : (
                    <span>
                        <img src={pendingBank} alt='pendingBank' style={{ width: '100%', margin: '0 auto', maxWidth:'80px' }}/>
                    </span> 
                );
            }
        },
    ], [selectedLoanId])

    return (

        <>
            <Dialog
                open={open}
                sx={{
                    zIndex: '9999999999999999',
                    '.MuiPaper-root': {
                        borderRadius: '12px',
                        width: '100%',
                        maxWidth: '468px',
                    },
                    '.MuiCardContent-root': {
                        padding: 0,

                    },
                }}
            >

                <Box sx={{ backgroundColor: "#F5F7FC", padding: '16px 12px' }}>
                    <Typography className='title-sm color-default' sx={{ marginBottom: '6px' }}>
                        {t("Copy Application Data")}
                    </Typography>

                    <Typography className='p-xsfs color-default' >
                        {t("Select the loan application you want to copy")}
                    </Typography>
                </Box>

                <DialogContent
                    sx={{
                        p: 0,
                        width: '100%',
                        overflowX: 'auto',
                        backgroundColor: 'white',
                    }}
                >

                    <DataGrid
                        key={selectedLoanId}
                        rowHeight={80}
                        sx={{
                            overflow: 'auto',
                            width: '100%',
                            minHeight: '160px',
                            '.MuiDataGrid-columnHeaderTitleContainerContent': {
                                overflow: {xs:'visible', sm:'hidden', md:'hidden'},
                            },
                            '& .MuiDataGrid-columnHeaderTitle': {
                                color: '#8891AC',
                                fontSize: '12px',
                            },

                            '.MuiDataGrid-cellContent': {
                                color: '#485476',
                                fontSize: {xs:'12px', sm:'12px', md: '14px'},
                            },
                            '& .MuiDataGrid-row:nth-of-type(odd)': {
                                backgroundColor: '#F5F7FC'
                            }
                        }}
                        columns={matchDownSM ? columnsMobile : columns }
                        density={'compact'}
                        rows={relatedApps}
                        getRowId={(row) => row.LoanId}
                        localeText={muiGridLocales(t)}
                        disableAggregation
                        disableRowGrouping
                        hideFooterPagination
                        hideFooter
                    />

                    <Grid container spacing={0}>
                        {notSelectedLoanId && (
                            <Grid item xs={12} sx={{textAlign:"center"}}>
                                <Typography variant="caption" color="error" sx={{padding:"5px"}}>
                                    {t('You must select a loan')}
                                </Typography>
                            </Grid>
                        )}
                        <Grid item xs={6}>
                            <Button
                                size="small"
                                variant="outlined"
                                color="info"
                                sx={{ width: '100%', fontSize:'12px', padding:'20px 0', color:'#42A69F !important', borderRadius: 'initial', lineHeight:'0', 'svg': { height: '16px'}}}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    getStructureData()
                                }}
                                startIcon={<Copy />}
                            >
                                {t('Copy')}
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                size="small"
                                variant="outlined"
                                color="error"
                                sx={{ width:'100%', fontSize:'12px', padding:'20px 0', color:'#A7605B !important', borderRadius: 'initial', lineHeight:'0', 'svg': { height: '16px'} }}                                
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onClose()
                                }}
                                startIcon={<CancelIcon />}
                            >
                                {t('Cancel')}
                            </Button>
                        </Grid>
                    </Grid>


                </DialogContent>

            </Dialog>
        </>

    );
};
export default CopyLoanPopup;
